<div class="profile-page" *ngIf="!isLoading && user">
    <!-- Error Banner -->
    <div class="error-banner" *ngIf="errorMessage">
        <p>{{ errorMessage }}</p>
    </div>

    <!-- LEFT COLUMN -->
    <div class="col-left">
        <!-- Profile Header -->
        <app-profile-header [user]="user" [mode]="mode" (profileUpdated)="onProfileUpdated($event)">
        </app-profile-header>

        <!-- Profile About -->
        <app-profile-about [about]="user.about" [mode]="mode">
        </app-profile-about>

        <!-- Profile Experience -->
        <app-profile-experience [experience]="user.experiences" [mode]="mode">
        </app-profile-experience>
    </div>

    <!-- RIGHT COLUMN -->
    <div class="col-right">
        <!-- Profile Completion -->
        <app-profile-completion [percentage]="user.completionPercent" *ngIf="mode=='edit'">
        </app-profile-completion>

        <!-- Profile Education -->
        <app-profile-education [education]="user.educations" [mode]="mode">
        </app-profile-education>

        <!-- Profile Skills -->
        <app-profile-skills [skills]="user.skills" [mode]="mode">
        </app-profile-skills>

        <!-- Profile Contact -->
        <app-profile-contact [email]="user.email" [phoneNumber]="user.phoneNumber" [linkedInLink]="user.linkedInLink"
            [cvUrl]="user.cvUrl" [name]="user.name">
        </app-profile-contact>
    </div>
</div>

<!-- Loading State -->
<div class="loading-state" *ngIf="isLoading">
    <p>{{ "userProfile.loading" | translate }}</p>
</div>

<!-- Empty State -->
<div class="empty-state" *ngIf="!isLoading && !user">
    <p>{{ "userProfile.empty" | translate }}</p>
</div>